window.theme = window.theme || {};

let selectedProducts = {
  bundle: {
    id: "",
    image: "",
    price: 0,
    compare_at_price: 0,
  },
  warranty: {
    id: "",
    price: 0,
    compare_at_price: 0,
  },
  bolts: {
    id: "",
    price: 0,
    compare_at_price: 0,
  },
  food: {
    id: "",
    price: 0,
    compare_at_price: 0,
  },
  play_packs: {
    id: "",
    price: 0,
    selling_plan: "",
    compare_at_price: 0,
  },
  toybox_plus: {
    id: "",
    price: 0,
    selling_plan: "",
    compare_at_price: 0,
  },
};
/*
try{
    const val = JSON.parse(localStorage.getItem("selectedProducts"))
    Object.keys(selectedProducts).forEach(key=>{
        selectedProducts[key] = val[key]
    })
}
catch(e){
    console.warn("Error",e)
}*/
console.log("LOAD PAGE", selectedProducts);
theme.PagePackageBuilder = (function () {
  var selectors = {
    section: ".js-product-package-section",
    button: ".js-product-package-button",
    multiSelect: ".js-product-package-multiselect",
    previewImage: ".js-package-builder-image",
    price: ".js-price",
    savings: ".js-savings",
    previewTitle: ".js-package-title",
    playPack: ".js-playpack-selector",
    plusPack: ".js-pluspack",
  };
  let sectionWrapper = $(selectors.section).get();
  function handleScroll(scrollDestination) {
    $(scrollDestination).removeClass("package-builder__section--light");
    $("html, body").animate(
      {
        scrollTop: $(scrollDestination).offset().top - 150,
      },
      1000
    );
  }
  function sumProduct(productsObj) {
    console.log(productsObj);
    let subTotalPrice = 0;
    let subTotalCompare = 0;

    Object.keys(productsObj).forEach((key) => {
      subTotalPrice += productsObj[key].price
        ? Number(productsObj[key].price)
        : 0;
      subTotalCompare += productsObj[key].compare_at_price
        ? Number(productsObj[key].compare_at_price)
        : 0;
    });
    return [subTotalPrice, subTotalCompare];
  }

  function handlePackageClick() {
    // setup the jquery selectors
    let clickedElement = $(this);
    let clickedWrapper = clickedElement.closest(selectors.section);
    let nextWrapper = $(clickedWrapper).next();
    let clickedSectionData = clickedWrapper.data("section");
    $(clickedElement).addClass("package-builder__btn--selected");

    //handle unhilighting everything when a "none" is clicked
    if (!clickedElement.data("variant-id")) {
      const elements = $(clickedElement).siblings(
        ".package-builder__btn--selected"
      );
      //remove food multiselect specific
      if (clickedSectionData === "food" && elements.length) {
        $(elements).each(function () {
          const objectName = `food_${$(this).data("variant-id")}`;
          delete selectedProducts[objectName];
        });
      }
    }

    //hanle the buttons highlighting
    if (!clickedElement.data("multiselect")) {
      $(clickedElement)
        .siblings()
        .removeClass("package-builder__btn--selected");
    }

    //handle removing none and on second click
    else if (clickedElement.data("multiselect")) {
      $(clickedElement)
        .siblings()
        .first()
        .removeClass("package-builder__btn--selected");
      const varId = $(clickedElement).data("variant-id");
      const varIdSearch = `${clickedSectionData}_${varId}`;
      if (selectedProducts[varIdSearch]) {
        console.log("should remove");
        $(clickedElement).removeClass("package-builder__btn--selected");
        delete selectedProducts[varIdSearch];
      }
    }

    // update the object that will be sent to the cart
    if (clickedSectionData) {
      if (
        clickedSectionData === "food" &&
        clickedElement.data("variant-id") &&
        $(clickedElement).hasClass("package-builder__btn--selected")
      ) {
        let foodSectionData = `food_${clickedElement.data("variant-id")}`;
        selectedProducts[foodSectionData] = {};
        handleCartObjectCreation(
          selectedProducts,
          foodSectionData,
          clickedElement
        );
      } else {
        handleCartObjectCreation(
          selectedProducts,
          clickedSectionData,
          clickedElement
        );
      }

      //special case for updating bundle image
      if (clickedSectionData === "bundle") {
        $(selectors.previewImage).attr(
          "srcset",
          clickedElement.data("product-image")
        );
        $(selectors.previewTitle).text(
          clickedElement.data("product-bundle-title")
        );

        //remove warranty
        selectedProducts.warranty = {
          id: "",
          price: 0,
          compare_at_price: 0,
        };

        //hides and shows correct warranty buttons
        const buttonsToHide = $('[data-section="warranty"]')
          .find(selectors.button)
          .filter(function () {
            return (
              $(this).data("product-price") &&
              !$(this)
                .data("product-title")
                .includes(selectedProducts.bundle.id)
            );
          });
        $(buttonsToHide).hide();

        const buttonsToShow = $('[data-section="warranty"]')
          .find(selectors.button)
          .filter(function () {
            return $(this)
              .data("product-title")
              .includes(selectedProducts.bundle.id);
          });
        $(buttonsToShow).show();
      }
    }

    // Price updating logic
    let [newSubTotal, newCompareTotal] = sumProduct(selectedProducts);
    let formattedSubTotal = theme.Currency.formatMoney(
      newSubTotal,
      theme.moneyFormat
    );
    let formattedSavings = theme.Currency.formatMoney(
      newCompareTotal - newSubTotal,
      theme.moneyFormat
    );
    $(selectors.price).text(formattedSubTotal);
    $(selectors.savings).text(`You are saving: ${formattedSavings}!`);

    // unlock the next section ands croll if it exists
    if (clickedWrapper.length && nextWrapper.length) {
      //scroll to the appriprate part skipping hidden section
      if ($(nextWrapper).is(":visible")) {
        handleScroll($(nextWrapper));
      } else {
        handleScroll($(nextWrapper).next());
      }
    }
    window.gtag("event", "selected_package_builder_item");
    console.log(selectedProducts);
    /*    try{
            localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts))

        }
        catch(e){
            console.warn(e)
        }*/
  }

  $(selectors.button).on("click", handlePackageClick);

  //adds grayed out sections (skipping playpacks)
  if (sectionWrapper.length > 0) {
    sectionWrapper.forEach(function (element, index) {
      if (index > 0) {
        $(element).addClass("package-builder__section--light");
      }
    });
  }

  //hide buttons that are not needed
  const allWarrantyButtons = $('[data-section="warranty"]')
    .find(selectors.button)
    .filter(function () {
      return $(this).data("product-price");
    });
  $(allWarrantyButtons).hide();

  //!$(this).data('product-title').includes('40352298926264')
})();

function handleBundleError(e) {
  console.error("Handle error", e);
  // TODO display an error some how?
}

function showBundleLoading(show) {
  console.error("Show loading", show);
  // TODO display an error some how?
}

function handleRemoveItem() {}

function handleCartObjectCreation(
  selectedProducts,
  clickedSectionData,
  clickedElement
) {
  console.log(clickedSectionData);
  selectedProducts[clickedSectionData].id = clickedElement.data("variant-id");
  console.log("CLICKED ITM", selectedProducts[clickedSectionData].id);
  selectedProducts[clickedSectionData].price =
    clickedElement.data("product-price");
  selectedProducts[clickedSectionData].compare_at_price =
    clickedElement.data("product-compare") ||
    clickedElement.data("product-price");
  selectedProducts[clickedSectionData].selling_plan =
    clickedElement.data("selling-plan");
}

function ToyboxPackageBuilderaddToCart() {
  const cart = {
    items: [],
  };

  function addProduct(val) {
    if (!val.id) {
      return;
    }
    if (val.items) {
      cart.items = cart.items.concat(val.items);
    } else {
      cart.items.push({
        quantity: val.quantity || 1,
        id: val.id,
        selling_plan: val.selling_plan,
      });
    }
  }
  if (!selectedProducts.bundle.id) {
    handleBundleError("Need to selecte a bundle.");
    return;
  }
  //reverse order so printer shows up first in order summary
  const productsToAdd = Object.keys(selectedProducts).reverse();
  for (let i = 0; i < productsToAdd.length; i++) {
    addProduct(selectedProducts[productsToAdd[i]]);
  }

  showBundleLoading(true);
  $.ajax({
    type: "POST",
    data: cart,
    url: "/cart/clear.js",
    dataType: "json",
    success: function (res) {
      $.ajax({
        type: "POST",
        data: cart,
        url: "/cart/add.js",
        dataType: "json",
        success: function (res) {
          showBundleLoading(false);
          window.gtag("event", "package_builder_add_to_cart");
          console.log("Added go to cart", res);
          window.location = "/checkout";
          //    localStorage.setItem("selectedProducts", null)
        },
        error: function (e) {
          console.error("Caught error adding to cart", e);
          try {
            console.log(JSON.parse(e.responseText));
          } catch (e) {}
          showBundleLoading(false);
          handleBundleError("Problem adding to cart");
        },
      });
    },
  });
}
